( function () {
	'use strict';

	/* Fixed arrow height in px (size is not user-adjustable) */
	var ARROW_H = 32;

	/* Default double-chevron SVG used when no custom image is set */
	var DEFAULT_SVG = [
		'<svg width="22" height="34" viewBox="0 0 22 34" fill="none" xmlns="http://www.w3.org/2000/svg"',
		' style="height:' + ARROW_H + 'px;width:auto;display:block">',
		'<path d="M2 2L11 17L2 32"  stroke="#F2994A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>',
		'<path d="M11 2L20 17L11 32" stroke="#F2994A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>',
		'</svg>',
	].join( '' );

	/* ── Inject arrows for one section ─────────────────────────────────── */
	function placeArrows( section ) {
		var arrowUrl = ( section.dataset.arrowUrl || '' ).trim();
		var grid     = section.querySelector( '.bbc-grid' );
		if ( ! grid ) { return; }

		var cards = Array.from( grid.querySelectorAll( '.bbc-card' ) );
		if ( cards.length < 2 ) { return; }

		/* ── 1. Ensure a physical column gap so the arrow has room to sit ── */
		/* This matches the gap-10 (40 px) used in the editor view.          */
		/* Setting the style and then calling getBoundingClientRect() below   */
		/* forces a synchronous layout reflow, so positions are always fresh. */
		if ( ! grid.style.columnGap && ! grid.style.gap ) {
			grid.style.columnGap = 'clamp(16px, 2.5vw, 40px)';
		}

		/* ── 2. Grid must be a positioning context for absolute children ─── */
		if ( window.getComputedStyle( grid ).position === 'static' ) {
			grid.style.position = 'relative';
		}

		/* ── 3. Remove any previously placed arrows ─────────────────────── */
		Array.from( grid.querySelectorAll( '.bbc-inter-arrow' ) ).forEach( function ( el ) {
			el.remove();
		} );

		/* ── 4. Read layout *after* gap is applied (forces reflow) ───────── */
		var gridRect      = grid.getBoundingClientRect();
		var containerEl   = section.querySelector( '.bbc-container' );
		var containerRect = containerEl ? containerEl.getBoundingClientRect() : gridRect;

		for ( var i = 0; i < cards.length - 1; i++ ) {
			var cur  = cards[ i ].getBoundingClientRect();
			var next = cards[ i + 1 ].getBoundingClientRect();

			/* Skip cards that haven't laid out yet */
			if ( cur.width === 0 || cur.height === 0 ) { continue; }

			/* Only draw when the two cards are on the same row.
			   Vertical offset > 40 % of card height → wrapped row → skip. */
			if ( Math.abs( cur.top - next.top ) > cur.height * 0.4 ) { continue; }

			/* Arrow centre point (absolute viewport coords) */
			var arrowAbsX = ( cur.right + next.left ) / 2;

			/* ── 5. Skip arrows that land outside the visible container ─── */
			/* This prevents "orphan" arrows appearing in overflow space      */
			/* when the grid is wider than the clipped container.             */
			if ( arrowAbsX < containerRect.left || arrowAbsX > containerRect.right ) { continue; }

			/* Convert to grid-relative coordinates */
			var cx = arrowAbsX - gridRect.left;
			var cy = cur.top + cur.height / 2 - gridRect.top;

			var div = document.createElement( 'div' );
			div.className = 'bbc-inter-arrow';
			div.setAttribute( 'aria-hidden', 'true' );
			div.style.cssText = [
				'position:absolute',
				'left:'      + cx + 'px',
				'top:'       + cy + 'px',
				'transform:translate(-50%,-50%)',
				'display:flex',
				'align-items:center',
				'justify-content:center',
				'pointer-events:none',
				'z-index:5',
			].join( ';' );

			if ( arrowUrl ) {
				/* User-supplied image from media library */
				var img = document.createElement( 'img' );
				img.src = arrowUrl;
				img.alt = '';
				img.style.cssText = 'height:' + ARROW_H + 'px;width:auto;object-fit:contain;display:block;';
				div.appendChild( img );
			} else {
				/* Default SVG double-chevron */
				div.innerHTML = DEFAULT_SVG;
			}

			grid.appendChild( div );
		}
	}

	/* ── Initialise all arrow sections ──────────────────────────────────── */
	function init() {
		document.querySelectorAll( '.bbc-section[data-show-arrows]' ).forEach( placeArrows );
	}

	/* Run after DOM is ready */
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}

	/* Re-run after ALL resources (images, fonts) have loaded so that
	   final card heights are correct before arrows are positioned.       */
	window.addEventListener( 'load', init );

	/* Re-run on resize (debounced) so positions stay correct */
	var resizeTimer;
	window.addEventListener( 'resize', function () {
		clearTimeout( resizeTimer );
		resizeTimer = setTimeout( init, 160 );
	} );

	/* ── Fix: replace <br> inside card headings with a plain space ──
	   Handles cases where a line break was accidentally inserted in the editor. ── */
	document.querySelectorAll( '.bbc-card-title br' ).forEach( function ( br ) {
		br.parentNode.replaceChild( document.createTextNode( ' ' ), br );
	} );

} )();
